var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6451",
    "data-name": "Groupe 6451",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 635.207,
    height: 464.36,
    viewBox: "0 0 635.207 464.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3785",
    "data-name": "Rectangle 3785",
    width: 635.207,
    height: 464.36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3624",
    "data-name": "Rectangle 3624",
    width: 127.822,
    height: 127.833,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3625",
    "data-name": "Rectangle 3625",
    width: 136.926,
    height: 162.017,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3745",
    "data-name": "Rectangle 3745",
    width: 127.823,
    height: 127.834,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3746",
    "data-name": "Rectangle 3746",
    width: 136.926,
    height: 162.016,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3751",
    "data-name": "Rectangle 3751",
    width: 48.938,
    height: 46.936,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3755",
    "data-name": "Rectangle 3755",
    width: 53.506,
    height: 5.74,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3757",
    "data-name": "Rectangle 3757",
    width: 33.859,
    height: 35.082,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3758",
    "data-name": "Rectangle 3758",
    width: 33.86,
    height: 35.083,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3760",
    "data-name": "Rectangle 3760",
    width: 130.421,
    height: 130.411,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3761",
    "data-name": "Rectangle 3761",
    width: 182.846,
    height: 130.282,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3763",
    "data-name": "Rectangle 3763",
    width: 8.824,
    height: 7.701,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3764",
    "data-name": "Rectangle 3764",
    width: 7.916,
    height: 3.482,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3765",
    "data-name": "Rectangle 3765",
    width: 1.733,
    height: 1.734,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3767",
    "data-name": "Rectangle 3767",
    width: 1.733,
    height: 1.733,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3768",
    "data-name": "Rectangle 3768",
    width: 11.2,
    height: 74.143,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3769",
    "data-name": "Rectangle 3769",
    width: 12.403,
    height: 17.694,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3770",
    "data-name": "Rectangle 3770",
    width: 6.221,
    height: 5.86,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3772",
    "data-name": "Rectangle 3772",
    width: 36.065,
    height: 200.835,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3773",
    "data-name": "Rectangle 3773",
    width: 5.968,
    height: 46.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3774",
    "data-name": "Rectangle 3774",
    width: 75.053,
    height: 200.415,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3775",
    "data-name": "Rectangle 3775",
    width: 2.091,
    height: 2.092,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3776",
    "data-name": "Rectangle 3776",
    width: 2.092,
    height: 2.092,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3778",
    "data-name": "Rectangle 3778",
    width: 36.402,
    height: 43.359,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3779",
    "data-name": "Rectangle 3779",
    width: 57.668,
    height: 55.819,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3780",
    "data-name": "Rectangle 3780",
    width: 3.448,
    height: 19.888,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3781",
    "data-name": "Rectangle 3781",
    width: 7.692,
    height: 11.709,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3782",
    "data-name": "Rectangle 3782",
    width: 19.315,
    height: 18.848,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3783",
    "data-name": "Rectangle 3783",
    width: 8.676,
    height: 15.155,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6537",
    "data-name": "Groupe 6537",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6444",
    "data-name": "Groupe 6444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6443",
    "data-name": "Groupe 6443",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5686",
    "data-name": "Trac\\xE9 5686",
    d: "M495.169,349.36H265.547a7.455,7.455,0,0,1-7.447-7.447V7.447A7.455,7.455,0,0,1,265.547,0H495.169a7.455,7.455,0,0,1,7.447,7.447V341.913a7.455,7.455,0,0,1-7.447,7.447M265.547.318a7.138,7.138,0,0,0-7.13,7.13V341.913a7.137,7.137,0,0,0,7.13,7.13H495.169a7.137,7.137,0,0,0,7.13-7.13V7.447a7.138,7.138,0,0,0-7.13-7.13Z",
    transform: "translate(69.794)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5687",
    "data-name": "Trac\\xE9 5687",
    d: "M286.743,349.36H57.119a7.455,7.455,0,0,1-7.447-7.447V7.447A7.455,7.455,0,0,1,57.119,0H286.743a7.455,7.455,0,0,1,7.447,7.447V341.913a7.455,7.455,0,0,1-7.447,7.447M57.119.318a7.138,7.138,0,0,0-7.13,7.13V341.913a7.138,7.138,0,0,0,7.13,7.13H286.743a7.138,7.138,0,0,0,7.13-7.13V7.447a7.138,7.138,0,0,0-7.13-7.13Z",
    transform: "translate(13.432)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3504",
    "data-name": "Rectangle 3504",
    width: 635.207,
    height: 0.318,
    transform: "translate(0 426.944)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3505",
    "data-name": "Rectangle 3505",
    width: 149.614,
    height: 220.985,
    transform: "translate(74.901 30.992)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3506",
    "data-name": "Rectangle 3506",
    width: 136.926,
    height: 208.297,
    transform: "translate(81.244 37.336)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5688",
    "data-name": "Trac\\xE9 5688",
    d: "M115.362,227.778V115.265h-4.684l-8.035-13.917L95.461,88.909V65.941H93.754V88.909l-7.182,12.439-8.034,13.917H73.854V227.778Z",
    transform: "translate(19.971 17.831)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3507",
    "data-name": "Rectangle 3507",
    width: 18.535,
    height: 141.124,
    transform: "translate(81.244 104.485)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5689",
    "data-name": "Trac\\xE9 5689",
    d: "M156.421,183.269V80.912l-40.651,16.7v85.654Z",
    transform: "translate(31.306 21.88)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3508",
    "data-name": "Rectangle 3508",
    width: 41.508,
    height: 112.513,
    transform: "translate(176.662 133.096)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3509",
    "data-name": "Rectangle 3509",
    width: 6.44,
    height: 3.022,
    transform: "translate(181.346 139.977)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3510",
    "data-name": "Rectangle 3510",
    width: 6.441,
    height: 3.022,
    transform: "translate(194.195 139.977)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3511",
    "data-name": "Rectangle 3511",
    width: 6.441,
    height: 3.022,
    transform: "translate(207.046 139.977)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3512",
    "data-name": "Rectangle 3512",
    width: 6.44,
    height: 3.021,
    transform: "translate(181.346 147.453)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3513",
    "data-name": "Rectangle 3513",
    width: 6.441,
    height: 3.021,
    transform: "translate(194.195 147.453)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3514",
    "data-name": "Rectangle 3514",
    width: 6.441,
    height: 3.021,
    transform: "translate(207.046 147.453)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3515",
    "data-name": "Rectangle 3515",
    width: 6.44,
    height: 3.022,
    transform: "translate(181.346 154.928)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3516",
    "data-name": "Rectangle 3516",
    width: 6.441,
    height: 3.022,
    transform: "translate(194.195 154.928)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3517",
    "data-name": "Rectangle 3517",
    width: 6.441,
    height: 3.022,
    transform: "translate(207.046 154.928)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3518",
    "data-name": "Rectangle 3518",
    width: 6.44,
    height: 3.022,
    transform: "translate(181.346 162.403)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3519",
    "data-name": "Rectangle 3519",
    width: 6.441,
    height: 3.022,
    transform: "translate(194.195 162.403)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3520",
    "data-name": "Rectangle 3520",
    width: 6.441,
    height: 3.022,
    transform: "translate(207.046 162.403)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3521",
    "data-name": "Rectangle 3521",
    width: 6.44,
    height: 3.022,
    transform: "translate(181.346 169.878)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3522",
    "data-name": "Rectangle 3522",
    width: 6.441,
    height: 3.022,
    transform: "translate(194.195 169.878)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3523",
    "data-name": "Rectangle 3523",
    width: 6.441,
    height: 3.022,
    transform: "translate(207.046 169.878)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3524",
    "data-name": "Rectangle 3524",
    width: 6.44,
    height: 3.022,
    transform: "translate(181.346 177.355)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3525",
    "data-name": "Rectangle 3525",
    width: 6.441,
    height: 3.022,
    transform: "translate(194.195 177.355)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3526",
    "data-name": "Rectangle 3526",
    width: 6.441,
    height: 3.022,
    transform: "translate(207.046 177.355)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3527",
    "data-name": "Rectangle 3527",
    width: 6.44,
    height: 3.022,
    transform: "translate(181.346 184.83)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3528",
    "data-name": "Rectangle 3528",
    width: 6.441,
    height: 3.022,
    transform: "translate(194.195 184.83)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3529",
    "data-name": "Rectangle 3529",
    width: 6.441,
    height: 3.022,
    transform: "translate(207.046 184.83)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3530",
    "data-name": "Rectangle 3530",
    width: 6.44,
    height: 3.021,
    transform: "translate(181.346 192.308)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3531",
    "data-name": "Rectangle 3531",
    width: 6.441,
    height: 3.021,
    transform: "translate(194.195 192.308)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3532",
    "data-name": "Rectangle 3532",
    width: 6.441,
    height: 3.021,
    transform: "translate(207.046 192.308)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3533",
    "data-name": "Rectangle 3533",
    width: 6.44,
    height: 3.022,
    transform: "translate(181.346 199.781)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3534",
    "data-name": "Rectangle 3534",
    width: 6.441,
    height: 3.022,
    transform: "translate(194.195 199.781)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3535",
    "data-name": "Rectangle 3535",
    width: 6.441,
    height: 3.022,
    transform: "translate(207.046 199.781)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3536",
    "data-name": "Rectangle 3536",
    width: 6.44,
    height: 3.022,
    transform: "translate(181.346 207.258)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3537",
    "data-name": "Rectangle 3537",
    width: 6.441,
    height: 3.022,
    transform: "translate(194.195 207.258)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3538",
    "data-name": "Rectangle 3538",
    width: 6.441,
    height: 3.022,
    transform: "translate(207.046 207.258)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3539",
    "data-name": "Rectangle 3539",
    width: 6.44,
    height: 3.022,
    transform: "translate(181.346 214.733)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3540",
    "data-name": "Rectangle 3540",
    width: 6.441,
    height: 3.022,
    transform: "translate(194.195 214.733)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3541",
    "data-name": "Rectangle 3541",
    width: 6.441,
    height: 3.022,
    transform: "translate(207.046 214.733)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3542",
    "data-name": "Rectangle 3542",
    width: 6.44,
    height: 3.021,
    transform: "translate(181.346 222.211)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3543",
    "data-name": "Rectangle 3543",
    width: 6.441,
    height: 3.021,
    transform: "translate(194.195 222.211)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3544",
    "data-name": "Rectangle 3544",
    width: 6.441,
    height: 3.021,
    transform: "translate(207.046 222.211)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3545",
    "data-name": "Rectangle 3545",
    width: 41.508,
    height: 112.513,
    transform: "translate(81.245 133.096)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3546",
    "data-name": "Rectangle 3546",
    width: 6.441,
    height: 3.022,
    transform: "translate(85.928 139.977)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3547",
    "data-name": "Rectangle 3547",
    width: 6.441,
    height: 3.022,
    transform: "translate(98.778 139.977)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3548",
    "data-name": "Rectangle 3548",
    width: 6.44,
    height: 3.022,
    transform: "translate(111.63 139.977)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3549",
    "data-name": "Rectangle 3549",
    width: 6.441,
    height: 3.021,
    transform: "translate(85.928 147.453)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3550",
    "data-name": "Rectangle 3550",
    width: 6.441,
    height: 3.021,
    transform: "translate(98.778 147.453)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3551",
    "data-name": "Rectangle 3551",
    width: 6.44,
    height: 3.021,
    transform: "translate(111.63 147.453)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3552",
    "data-name": "Rectangle 3552",
    width: 6.441,
    height: 3.022,
    transform: "translate(85.928 154.928)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3553",
    "data-name": "Rectangle 3553",
    width: 6.441,
    height: 3.022,
    transform: "translate(98.778 154.928)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3554",
    "data-name": "Rectangle 3554",
    width: 6.44,
    height: 3.022,
    transform: "translate(111.63 154.928)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3555",
    "data-name": "Rectangle 3555",
    width: 6.441,
    height: 3.022,
    transform: "translate(85.928 162.403)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3556",
    "data-name": "Rectangle 3556",
    width: 6.441,
    height: 3.022,
    transform: "translate(98.778 162.403)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3557",
    "data-name": "Rectangle 3557",
    width: 6.44,
    height: 3.022,
    transform: "translate(111.63 162.403)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3558",
    "data-name": "Rectangle 3558",
    width: 6.441,
    height: 3.022,
    transform: "translate(85.928 169.878)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3559",
    "data-name": "Rectangle 3559",
    width: 6.441,
    height: 3.022,
    transform: "translate(98.778 169.878)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3560",
    "data-name": "Rectangle 3560",
    width: 6.44,
    height: 3.022,
    transform: "translate(111.63 169.878)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3561",
    "data-name": "Rectangle 3561",
    width: 6.441,
    height: 3.022,
    transform: "translate(85.928 177.355)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3562",
    "data-name": "Rectangle 3562",
    width: 6.441,
    height: 3.022,
    transform: "translate(98.778 177.355)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3563",
    "data-name": "Rectangle 3563",
    width: 6.44,
    height: 3.022,
    transform: "translate(111.63 177.355)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3564",
    "data-name": "Rectangle 3564",
    width: 6.441,
    height: 3.022,
    transform: "translate(85.928 184.83)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3565",
    "data-name": "Rectangle 3565",
    width: 6.441,
    height: 3.022,
    transform: "translate(98.778 184.83)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3566",
    "data-name": "Rectangle 3566",
    width: 6.44,
    height: 3.022,
    transform: "translate(111.63 184.83)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3567",
    "data-name": "Rectangle 3567",
    width: 6.441,
    height: 3.021,
    transform: "translate(85.928 192.308)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3568",
    "data-name": "Rectangle 3568",
    width: 6.441,
    height: 3.021,
    transform: "translate(98.778 192.308)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3569",
    "data-name": "Rectangle 3569",
    width: 6.44,
    height: 3.021,
    transform: "translate(111.63 192.308)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3570",
    "data-name": "Rectangle 3570",
    width: 6.441,
    height: 3.022,
    transform: "translate(85.928 199.781)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3571",
    "data-name": "Rectangle 3571",
    width: 6.441,
    height: 3.022,
    transform: "translate(98.778 199.781)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3572",
    "data-name": "Rectangle 3572",
    width: 6.44,
    height: 3.022,
    transform: "translate(111.63 199.781)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3573",
    "data-name": "Rectangle 3573",
    width: 6.441,
    height: 3.022,
    transform: "translate(85.928 207.258)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3574",
    "data-name": "Rectangle 3574",
    width: 6.441,
    height: 3.022,
    transform: "translate(98.778 207.258)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3575",
    "data-name": "Rectangle 3575",
    width: 6.44,
    height: 3.022,
    transform: "translate(111.63 207.258)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3576",
    "data-name": "Rectangle 3576",
    width: 6.441,
    height: 3.022,
    transform: "translate(85.928 214.733)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3577",
    "data-name": "Rectangle 3577",
    width: 6.441,
    height: 3.022,
    transform: "translate(98.778 214.733)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3578",
    "data-name": "Rectangle 3578",
    width: 6.44,
    height: 3.022,
    transform: "translate(111.63 214.733)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3579",
    "data-name": "Rectangle 3579",
    width: 6.441,
    height: 3.021,
    transform: "translate(85.928 222.211)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3580",
    "data-name": "Rectangle 3580",
    width: 6.441,
    height: 3.021,
    transform: "translate(98.778 222.211)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3581",
    "data-name": "Rectangle 3581",
    width: 6.44,
    height: 3.021,
    transform: "translate(111.63 222.211)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5690",
    "data-name": "Trac\\xE9 5690",
    d: "M158.816,110.691H142.745l8.035-13.917,8.035-13.917,8.035,13.917,8.035,13.917Z",
    transform: "translate(38.6 22.405)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3582",
    "data-name": "Rectangle 3582",
    width: 1.707,
    height: 31.729,
    transform: "translate(196.562 83.772)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3583",
    "data-name": "Rectangle 3583",
    width: 44.495,
    height: 105.632,
    transform: "translate(128.727 139.977)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3584",
    "data-name": "Rectangle 3584",
    width: 16.789,
    height: 14.326,
    transform: "translate(131.999 136.364)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3585",
    "data-name": "Rectangle 3585",
    width: 4.5,
    height: 12.863,
    transform: "translate(133.51 135.308)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3586",
    "data-name": "Rectangle 3586",
    width: 4.501,
    height: 12.863,
    transform: "translate(142.876 135.308)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3587",
    "data-name": "Rectangle 3587",
    width: 9.994,
    height: 9.994,
    transform: "translate(160.383 136.415)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3588",
    "data-name": "Rectangle 3588",
    width: 6.441,
    height: 3.022,
    transform: "translate(135.26 148.962)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3589",
    "data-name": "Rectangle 3589",
    width: 6.441,
    height: 3.022,
    transform: "translate(148.11 148.962)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3590",
    "data-name": "Rectangle 3590",
    width: 6.441,
    height: 3.022,
    transform: "translate(160.96 148.962)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3591",
    "data-name": "Rectangle 3591",
    width: 6.441,
    height: 3.022,
    transform: "translate(135.26 156.439)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3592",
    "data-name": "Rectangle 3592",
    width: 6.441,
    height: 3.022,
    transform: "translate(148.11 156.439)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3593",
    "data-name": "Rectangle 3593",
    width: 6.441,
    height: 3.022,
    transform: "translate(160.96 156.439)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3594",
    "data-name": "Rectangle 3594",
    width: 6.441,
    height: 3.022,
    transform: "translate(135.26 163.914)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3595",
    "data-name": "Rectangle 3595",
    width: 6.441,
    height: 3.022,
    transform: "translate(148.11 163.914)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3596",
    "data-name": "Rectangle 3596",
    width: 6.441,
    height: 3.022,
    transform: "translate(160.96 163.914)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3597",
    "data-name": "Rectangle 3597",
    width: 6.441,
    height: 3.021,
    transform: "translate(135.26 171.392)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3598",
    "data-name": "Rectangle 3598",
    width: 6.441,
    height: 3.021,
    transform: "translate(148.11 171.392)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3599",
    "data-name": "Rectangle 3599",
    width: 6.441,
    height: 3.021,
    transform: "translate(160.96 171.392)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3600",
    "data-name": "Rectangle 3600",
    width: 6.441,
    height: 3.022,
    transform: "translate(135.26 178.865)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3601",
    "data-name": "Rectangle 3601",
    width: 6.441,
    height: 3.022,
    transform: "translate(148.11 178.865)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3602",
    "data-name": "Rectangle 3602",
    width: 6.441,
    height: 3.022,
    transform: "translate(160.96 178.865)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3603",
    "data-name": "Rectangle 3603",
    width: 6.441,
    height: 3.022,
    transform: "translate(135.26 186.342)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3604",
    "data-name": "Rectangle 3604",
    width: 6.441,
    height: 3.022,
    transform: "translate(148.11 186.342)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3605",
    "data-name": "Rectangle 3605",
    width: 6.441,
    height: 3.022,
    transform: "translate(160.96 186.342)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3606",
    "data-name": "Rectangle 3606",
    width: 6.441,
    height: 3.021,
    transform: "translate(135.26 193.818)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3607",
    "data-name": "Rectangle 3607",
    width: 6.441,
    height: 3.021,
    transform: "translate(148.11 193.818)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3608",
    "data-name": "Rectangle 3608",
    width: 6.441,
    height: 3.021,
    transform: "translate(160.96 193.818)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3609",
    "data-name": "Rectangle 3609",
    width: 6.441,
    height: 3.022,
    transform: "translate(135.26 201.293)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3610",
    "data-name": "Rectangle 3610",
    width: 6.441,
    height: 3.022,
    transform: "translate(148.11 201.293)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3611",
    "data-name": "Rectangle 3611",
    width: 6.441,
    height: 3.022,
    transform: "translate(160.96 201.293)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3612",
    "data-name": "Rectangle 3612",
    width: 6.441,
    height: 3.022,
    transform: "translate(135.26 208.768)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3613",
    "data-name": "Rectangle 3613",
    width: 6.441,
    height: 3.022,
    transform: "translate(148.11 208.768)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3614",
    "data-name": "Rectangle 3614",
    width: 6.441,
    height: 3.022,
    transform: "translate(160.96 208.768)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3615",
    "data-name": "Rectangle 3615",
    width: 6.441,
    height: 3.022,
    transform: "translate(135.26 216.245)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3616",
    "data-name": "Rectangle 3616",
    width: 6.441,
    height: 3.022,
    transform: "translate(148.11 216.245)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3617",
    "data-name": "Rectangle 3617",
    width: 6.441,
    height: 3.022,
    transform: "translate(160.96 216.245)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3618",
    "data-name": "Rectangle 3618",
    width: 6.441,
    height: 3.021,
    transform: "translate(135.26 223.721)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3619",
    "data-name": "Rectangle 3619",
    width: 6.441,
    height: 3.021,
    transform: "translate(148.11 223.721)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3620",
    "data-name": "Rectangle 3620",
    width: 6.441,
    height: 3.021,
    transform: "translate(160.96 223.721)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3621",
    "data-name": "Rectangle 3621",
    width: 6.441,
    height: 3.022,
    transform: "translate(135.26 231.196)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3622",
    "data-name": "Rectangle 3622",
    width: 6.441,
    height: 3.022,
    transform: "translate(148.11 231.196)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3623",
    "data-name": "Rectangle 3623",
    width: 6.441,
    height: 3.022,
    transform: "translate(160.96 231.196)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6433",
    "data-name": "Groupe 6433",
    transform: "translate(81.245 37.336)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6432",
    "data-name": "Groupe 6432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6431",
    "data-name": "Groupe 6431",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5691",
    "data-name": "Trac\\xE9 5691",
    d: "M191.774,29.389,63.951,157.222V120.511l91.122-91.122Z",
    transform: "translate(-63.951 -29.389)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6436",
    "data-name": "Groupe 6436",
    transform: "translate(81.245 83.616)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6435",
    "data-name": "Groupe 6435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6434",
    "data-name": "Groupe 6434",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5692",
    "data-name": "Trac\\xE9 5692",
    d: "M200.878,65.818v26.2L65.061,227.835h-1.11V202.755Z",
    transform: "translate(-63.951 -65.818)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3626",
    "data-name": "Rectangle 3626",
    width: 149.614,
    height: 220.986,
    transform: "translate(409.747 32.561)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3627",
    "data-name": "Rectangle 3627",
    width: 136.926,
    height: 208.297,
    transform: "translate(416.091 38.904)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5693",
    "data-name": "Trac\\xE9 5693",
    d: "M378.935,229.012V116.5h-4.684l-8.035-13.917-7.182-12.44V67.175h-1.706V90.142l-7.182,12.44L342.111,116.5h-4.684V229.012Z",
    transform: "translate(91.245 18.165)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3628",
    "data-name": "Rectangle 3628",
    width: 18.535,
    height: 141.123,
    transform: "translate(416.091 106.054)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5694",
    "data-name": "Trac\\xE9 5694",
    d: "M419.994,184.5V82.146l-40.652,16.7V184.5Z",
    transform: "translate(102.579 22.213)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3629",
    "data-name": "Rectangle 3629",
    width: 41.508,
    height: 112.513,
    transform: "translate(511.509 134.665)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3630",
    "data-name": "Rectangle 3630",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 141.544)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3631",
    "data-name": "Rectangle 3631",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 141.544)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3632",
    "data-name": "Rectangle 3632",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 141.544)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3633",
    "data-name": "Rectangle 3633",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 149.021)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3634",
    "data-name": "Rectangle 3634",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 149.021)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3635",
    "data-name": "Rectangle 3635",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 149.021)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3636",
    "data-name": "Rectangle 3636",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 156.496)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3637",
    "data-name": "Rectangle 3637",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 156.496)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3638",
    "data-name": "Rectangle 3638",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 156.496)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3639",
    "data-name": "Rectangle 3639",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 163.972)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3640",
    "data-name": "Rectangle 3640",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 163.972)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3641",
    "data-name": "Rectangle 3641",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 163.972)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3642",
    "data-name": "Rectangle 3642",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 171.447)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3643",
    "data-name": "Rectangle 3643",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 171.447)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3644",
    "data-name": "Rectangle 3644",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 171.447)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3645",
    "data-name": "Rectangle 3645",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 178.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3646",
    "data-name": "Rectangle 3646",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 178.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3647",
    "data-name": "Rectangle 3647",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 178.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3648",
    "data-name": "Rectangle 3648",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 186.399)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3649",
    "data-name": "Rectangle 3649",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 186.399)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3650",
    "data-name": "Rectangle 3650",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 186.399)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3651",
    "data-name": "Rectangle 3651",
    width: 6.441,
    height: 3.021,
    transform: "translate(516.192 193.875)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3652",
    "data-name": "Rectangle 3652",
    width: 6.441,
    height: 3.021,
    transform: "translate(529.042 193.875)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3653",
    "data-name": "Rectangle 3653",
    width: 6.441,
    height: 3.021,
    transform: "translate(541.892 193.875)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3654",
    "data-name": "Rectangle 3654",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 201.35)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3655",
    "data-name": "Rectangle 3655",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 201.35)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3656",
    "data-name": "Rectangle 3656",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 201.35)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3657",
    "data-name": "Rectangle 3657",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 208.826)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3658",
    "data-name": "Rectangle 3658",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 208.826)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3659",
    "data-name": "Rectangle 3659",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 208.826)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3660",
    "data-name": "Rectangle 3660",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 216.302)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3661",
    "data-name": "Rectangle 3661",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 216.302)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3662",
    "data-name": "Rectangle 3662",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 216.302)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3663",
    "data-name": "Rectangle 3663",
    width: 6.441,
    height: 3.022,
    transform: "translate(516.192 223.777)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3664",
    "data-name": "Rectangle 3664",
    width: 6.441,
    height: 3.022,
    transform: "translate(529.042 223.777)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3665",
    "data-name": "Rectangle 3665",
    width: 6.441,
    height: 3.022,
    transform: "translate(541.892 223.777)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3666",
    "data-name": "Rectangle 3666",
    width: 41.508,
    height: 112.513,
    transform: "translate(416.091 134.665)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3667",
    "data-name": "Rectangle 3667",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 141.544)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3668",
    "data-name": "Rectangle 3668",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 141.544)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3669",
    "data-name": "Rectangle 3669",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 141.544)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3670",
    "data-name": "Rectangle 3670",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 149.021)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3671",
    "data-name": "Rectangle 3671",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 149.021)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3672",
    "data-name": "Rectangle 3672",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 149.021)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3673",
    "data-name": "Rectangle 3673",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 156.496)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3674",
    "data-name": "Rectangle 3674",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 156.496)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3675",
    "data-name": "Rectangle 3675",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 156.496)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3676",
    "data-name": "Rectangle 3676",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 163.972)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3677",
    "data-name": "Rectangle 3677",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 163.972)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3678",
    "data-name": "Rectangle 3678",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 163.972)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3679",
    "data-name": "Rectangle 3679",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 171.447)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3680",
    "data-name": "Rectangle 3680",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 171.447)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3681",
    "data-name": "Rectangle 3681",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 171.447)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3682",
    "data-name": "Rectangle 3682",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 178.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3683",
    "data-name": "Rectangle 3683",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 178.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3684",
    "data-name": "Rectangle 3684",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 178.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3685",
    "data-name": "Rectangle 3685",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 186.399)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3686",
    "data-name": "Rectangle 3686",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 186.399)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3687",
    "data-name": "Rectangle 3687",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 186.399)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3688",
    "data-name": "Rectangle 3688",
    width: 6.441,
    height: 3.021,
    transform: "translate(420.775 193.875)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3689",
    "data-name": "Rectangle 3689",
    width: 6.441,
    height: 3.021,
    transform: "translate(433.625 193.875)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3690",
    "data-name": "Rectangle 3690",
    width: 6.441,
    height: 3.021,
    transform: "translate(446.475 193.875)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3691",
    "data-name": "Rectangle 3691",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 201.35)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3692",
    "data-name": "Rectangle 3692",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 201.35)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3693",
    "data-name": "Rectangle 3693",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 201.35)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3694",
    "data-name": "Rectangle 3694",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 208.826)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3695",
    "data-name": "Rectangle 3695",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 208.826)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3696",
    "data-name": "Rectangle 3696",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 208.826)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 216.302)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3698",
    "data-name": "Rectangle 3698",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 216.302)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3699",
    "data-name": "Rectangle 3699",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 216.302)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3700",
    "data-name": "Rectangle 3700",
    width: 6.441,
    height: 3.022,
    transform: "translate(420.775 223.777)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3701",
    "data-name": "Rectangle 3701",
    width: 6.441,
    height: 3.022,
    transform: "translate(433.625 223.777)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3702",
    "data-name": "Rectangle 3702",
    width: 6.441,
    height: 3.022,
    transform: "translate(446.475 223.777)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5695",
    "data-name": "Trac\\xE9 5695",
    d: "M422.389,111.925H406.318l8.036-13.917,8.035-13.917,8.035,13.917,8.035,13.917Z",
    transform: "translate(109.874 22.739)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3703",
    "data-name": "Rectangle 3703",
    width: 1.707,
    height: 31.729,
    transform: "translate(531.409 85.34)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3704",
    "data-name": "Rectangle 3704",
    width: 44.495,
    height: 105.632,
    transform: "translate(463.574 141.544)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3705",
    "data-name": "Rectangle 3705",
    width: 16.789,
    height: 14.326,
    transform: "translate(466.845 137.931)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3706",
    "data-name": "Rectangle 3706",
    width: 4.501,
    height: 12.863,
    transform: "translate(468.356 136.876)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3707",
    "data-name": "Rectangle 3707",
    width: 4.501,
    height: 12.863,
    transform: "translate(477.723 136.876)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3708",
    "data-name": "Rectangle 3708",
    width: 9.994,
    height: 9.994,
    transform: "translate(495.23 137.982)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3709",
    "data-name": "Rectangle 3709",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 150.531)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3710",
    "data-name": "Rectangle 3710",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 150.531)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3711",
    "data-name": "Rectangle 3711",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 150.531)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 158.006)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3713",
    "data-name": "Rectangle 3713",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 158.006)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3714",
    "data-name": "Rectangle 3714",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 158.006)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3715",
    "data-name": "Rectangle 3715",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 165.483)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3716",
    "data-name": "Rectangle 3716",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 165.483)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3717",
    "data-name": "Rectangle 3717",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 165.483)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3718",
    "data-name": "Rectangle 3718",
    width: 6.441,
    height: 3.021,
    transform: "translate(470.105 172.959)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3719",
    "data-name": "Rectangle 3719",
    width: 6.441,
    height: 3.021,
    transform: "translate(482.957 172.959)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3720",
    "data-name": "Rectangle 3720",
    width: 6.441,
    height: 3.021,
    transform: "translate(495.807 172.959)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3721",
    "data-name": "Rectangle 3721",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 180.434)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3722",
    "data-name": "Rectangle 3722",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 180.434)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3723",
    "data-name": "Rectangle 3723",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 180.434)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3724",
    "data-name": "Rectangle 3724",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 187.909)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3725",
    "data-name": "Rectangle 3725",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 187.909)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3726",
    "data-name": "Rectangle 3726",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 187.909)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3727",
    "data-name": "Rectangle 3727",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 195.386)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3728",
    "data-name": "Rectangle 3728",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 195.386)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3729",
    "data-name": "Rectangle 3729",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 195.386)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3730",
    "data-name": "Rectangle 3730",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 202.861)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3731",
    "data-name": "Rectangle 3731",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 202.861)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3732",
    "data-name": "Rectangle 3732",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 202.861)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3733",
    "data-name": "Rectangle 3733",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 210.337)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3734",
    "data-name": "Rectangle 3734",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 210.337)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3735",
    "data-name": "Rectangle 3735",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 210.337)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3736",
    "data-name": "Rectangle 3736",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 217.812)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3737",
    "data-name": "Rectangle 3737",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 217.812)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3738",
    "data-name": "Rectangle 3738",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 217.812)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3739",
    "data-name": "Rectangle 3739",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 225.289)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3740",
    "data-name": "Rectangle 3740",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 225.289)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3741",
    "data-name": "Rectangle 3741",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 225.289)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3742",
    "data-name": "Rectangle 3742",
    width: 6.441,
    height: 3.022,
    transform: "translate(470.105 232.764)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3743",
    "data-name": "Rectangle 3743",
    width: 6.441,
    height: 3.022,
    transform: "translate(482.957 232.764)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3744",
    "data-name": "Rectangle 3744",
    width: 6.441,
    height: 3.022,
    transform: "translate(495.807 232.764)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6439",
    "data-name": "Groupe 6439",
    transform: "translate(416.091 38.904)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6438",
    "data-name": "Groupe 6438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6437",
    "data-name": "Groupe 6437",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5696",
    "data-name": "Trac\\xE9 5696",
    d: "M455.347,30.623,327.524,158.456V121.745l91.122-91.122Z",
    transform: "translate(-327.524 -30.623)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6442",
    "data-name": "Groupe 6442",
    transform: "translate(416.091 85.185)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6441",
    "data-name": "Groupe 6441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6440",
    "data-name": "Groupe 6440",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5697",
    "data-name": "Trac\\xE9 5697",
    d: "M464.451,67.053v26.2L328.634,229.07h-1.11V203.989Z",
    transform: "translate(-327.524 -67.053)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5698",
    "data-name": "Trac\\xE9 5698",
    d: "M325.2,227.845H105.17a6.745,6.745,0,0,0,6.745,6.745H318.458a6.745,6.745,0,0,0,6.745-6.745",
    transform: "translate(28.439 61.612)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3747",
    "data-name": "Rectangle 3747",
    width: 131.611,
    height: 6.24,
    transform: "translate(178.815 353.251)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5699",
    "data-name": "Trac\\xE9 5699",
    d: "M242.025,364.054l17.939-130.9h-6.3l-17.94,130.9Z",
    transform: "translate(63.743 63.048)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5700",
    "data-name": "Trac\\xE9 5700",
    d: "M256.173,364.054l-18.229-130.9h6.3l18.229,130.9Z",
    transform: "translate(64.343 63.048)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5701",
    "data-name": "Trac\\xE9 5701",
    d: "M134.168,364.054l18.707-130.9h-6.3l-18.707,130.9Z",
    transform: "translate(34.577 63.048)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5702",
    "data-name": "Trac\\xE9 5702",
    d: "M148.255,364.054l-17.94-130.9h6.3l17.94,130.9Z",
    transform: "translate(35.239 63.048)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3748",
    "data-name": "Rectangle 3748",
    width: 234.799,
    height: 10.867,
    transform: "translate(126.226 278.632)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5703",
    "data-name": "Trac\\xE9 5703",
    d: "M165.967,220.557H267.859l1.107-2.5c.695-1.574-1.119-3.142-3.636-3.142H171.31c-1.686,0-3.17.725-3.636,1.78Z",
    transform: "translate(44.88 58.116)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5704",
    "data-name": "Trac\\xE9 5704",
    d: "M289.407,164.379l-13.042,55.163a3.259,3.259,0,0,1-3.171,2.508H192.849a3.258,3.258,0,0,1-3.171-4.007L202.72,162.88a3.257,3.257,0,0,1,3.171-2.508h80.345a3.258,3.258,0,0,1,3.171,4.007",
    transform: "translate(51.267 43.367)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5705",
    "data-name": "Trac\\xE9 5705",
    d: "M240.116,187.682a7.2,7.2,0,0,1-6.98,6.286,5.522,5.522,0,0,1-5.594-6.286,7.2,7.2,0,0,1,6.98-6.287,5.523,5.523,0,0,1,5.594,6.287",
    transform: "translate(61.52 49.052)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5706",
    "data-name": "Trac\\xE9 5706",
    d: "M209.075,160.372l-13.886,61.677h-2.34a3.258,3.258,0,0,1-3.171-4.007L202.72,162.88a3.259,3.259,0,0,1,3.171-2.508Z",
    transform: "translate(51.267 43.367)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5707",
    "data-name": "Trac\\xE9 5707",
    d: "M223.829,208.92l-2.739,13.1h8.051l2.739-13.1Z",
    transform: "translate(59.786 56.495)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5708",
    "data-name": "Trac\\xE9 5708",
    d: "M211.9,218.263l1.648-2.317a3.137,3.137,0,0,1,2.555-1.319h22.073a3.137,3.137,0,0,1,2.778,1.685l1.112,2.125a1.492,1.492,0,0,1-1.322,2.184H213.119a1.492,1.492,0,0,1-1.216-2.358",
    transform: "translate(57.226 58.038)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5709",
    "data-name": "Trac\\xE9 5709",
    d: "M400.482,332.1s-10.722,2.376-9.129-5.1,1.476-10.238-2.88-13.639-8.744-5.079-5.407-10.462-2.993-9.569-6.267-12.466.422-5.083,1.288-10.561-5.026-4.655-5.488-11.554,6.546-14.963.52-24.461c0,0,8.094,4.2,10.753,11.572s.512,13.069,5.294,15.871,7.775,7.65,6.153,12.625.682,7.614,4.6,11.242,2.876,5.07,2.39,9.507.49,3.388,4.979,9.448,4.6,15.994-6.806,17.983",
    transform: "translate(100.75 65.941)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5710",
    "data-name": "Trac\\xE9 5710",
    d: "M400.327,327.087a.532.532,0,0,1-.054-.115l-21.452-65.114a.533.533,0,0,1,.338-.673l.01,0a.535.535,0,0,1,.666.344l21.452,65.113a.526.526,0,0,1,.028.159Z",
    transform: "translate(102.431 70.621)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5711",
    "data-name": "Trac\\xE9 5711",
    d: "M411.81,331.892s10.664,2.363,9.08-5.078-1.469-10.184,2.866-13.565,8.7-5.052,5.378-10.407,2.978-9.518,6.233-12.4-.419-5.056-1.281-10.5,5-4.629,5.459-11.492-6.511-14.885-.517-24.331c0,0-8.051,4.176-10.7,11.51s-.509,13-5.266,15.787-7.734,7.61-6.118,12.558-.68,7.573-4.579,11.182-2.862,5.044-2.377,9.457-.488,3.369-4.952,9.4-4.577,15.908,6.77,17.886",
    transform: "translate(108.767 66.012)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5712",
    "data-name": "Trac\\xE9 5712",
    d: "M407.8,326.619a.523.523,0,0,1,.027-.159l21.339-64.767a.532.532,0,0,1,.662-.342l.01,0a.531.531,0,0,1,.337.67l-21.339,64.769a.5.5,0,0,1-.053.114Z",
    transform: "translate(110.275 70.667)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5713",
    "data-name": "Trac\\xE9 5713",
    d: "M403.057,334.195s-12.272-1.016-8.081-8.5,4.981-10.476,1.443-15.565-7.677-8.343-2.316-13-.029-11.243-2.571-15.433,2.139-5.3,4.887-10.884-3.838-6.654-2.042-14.2,11.98-13.853,8.68-26.026c0,0,7.276,7.184,7.675,15.964s-3.791,14.169.4,18.759,5.787,10.776,2.395,15.565-1.8,8.381,1.2,13.569,1.4,6.385-.6,10.975-.6,3.792,2.2,11.774-.382,18.659-13.262,17",
    transform: "translate(105.678 62.354)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5714",
    "data-name": "Trac\\xE9 5714",
    d: "M402.116,328.783a.567.567,0,0,1-.022-.141l-1.353-76.866a.6.6,0,0,1,.587-.609h.014a.6.6,0,0,1,.6.588l1.352,76.864a.615.615,0,0,1-.024.18Z",
    transform: "translate(108.366 67.919)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5715",
    "data-name": "Trac\\xE9 5715",
    d: "M440.054,307.468H380.032a2.467,2.467,0,0,0-2.31,3.34l.888,2.355.56,1.494,1.612,4.276.563,1.494L383,324.819l.562,1.49,6.6,17.531h39.759l6.6-17.531.562-1.49,1.654-4.392.564-1.494,1.61-4.276.562-1.494.888-2.355a2.47,2.47,0,0,0-2.31-3.34",
    transform: "translate(102.098 83.144)",
    fill: "#e6e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6446",
    "data-name": "Groupe 6446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6445",
    "data-name": "Groupe 6445",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5716",
    "data-name": "Trac\\xE9 5716",
    d: "M545.39,361.089c0,4.261-110.523,7.714-246.862,7.714S51.667,365.35,51.667,361.089s110.523-7.714,246.862-7.714,246.862,3.453,246.862,7.714",
    transform: "translate(13.971 95.557)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5717",
    "data-name": "Trac\\xE9 5717",
    d: "M125.878,322.332l-10.442,46.937H87.381l-10.44-46.937Z",
    transform: "translate(20.806 87.163)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6451-2",
    "data-name": "Groupe 6451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6450",
    "data-name": "Groupe 6450",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6449",
    "data-name": "Groupe 6449",
    transform: "translate(97.746 409.494)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6448",
    "data-name": "Groupe 6448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6447",
    "data-name": "Groupe 6447",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5718",
    "data-name": "Trac\\xE9 5718",
    d: "M125.878,322.332l-10.442,46.937H87.381l-10.44-46.937Z",
    transform: "translate(-76.94 -322.332)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3753",
    "data-name": "Rectangle 3753",
    width: 53.506,
    height: 5.74,
    transform: "translate(95.281 409.495)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6456",
    "data-name": "Groupe 6456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6455",
    "data-name": "Groupe 6455",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6454",
    "data-name": "Groupe 6454",
    transform: "translate(95.281 409.494)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6453",
    "data-name": "Groupe 6453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6452",
    "data-name": "Groupe 6452",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3754",
    "data-name": "Rectangle 3754",
    width: 53.506,
    height: 5.74,
    transform: "translate(0 0.001)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5719",
    "data-name": "Trac\\xE9 5719",
    d: "M98.58,336.512h1.236c.635-38.538-9.989-66.2-10.109-66.509-.127-.323-1.279.13-1.154.452.119.3,10.664,27.759,10.026,66.056",
    transform: "translate(23.944 72.983)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5720",
    "data-name": "Trac\\xE9 5720",
    d: "M94.553,295.439s-4.247-12.972,19.159-17.471c0,0-.431,22.725-19.159,17.471",
    transform: "translate(25.487 75.166)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5721",
    "data-name": "Trac\\xE9 5721",
    d: "M96.5,312.318s-4.247-12.972,19.159-17.471c0,0-.431,22.725-19.159,17.471",
    transform: "translate(26.014 79.731)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5722",
    "data-name": "Trac\\xE9 5722",
    d: "M101.028,300.475s-1.371-13.581-24.594-8.213c0,0,9.6,20.6,24.594,8.213",
    transform: "translate(20.669 78.692)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5723",
    "data-name": "Trac\\xE9 5723",
    d: "M102.123,315.853s-1.371-13.581-24.594-8.213c0,0,9.6,20.6,24.594,8.213",
    transform: "translate(20.965 82.851)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5724",
    "data-name": "Trac\\xE9 5724",
    d: "M95.061,286.773s-13.616.943-12.249-22.853c0,0,21.929,5.982,12.249,22.853",
    transform: "translate(22.367 71.368)",
    fill: "#407bff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6464",
    "data-name": "Groupe 6464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6463",
    "data-name": "Groupe 6463",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5725",
    "data-name": "Trac\\xE9 5725",
    d: "M349.96,235.549a12.433,12.433,0,0,0,2.36,2.424l-1.972,4.676,5.124,2.161,1.888-4.477a12.316,12.316,0,0,0,3.645.239l2.142,5.265,5.152-2.095-1.976-4.855a12.458,12.458,0,0,0,3.538-3.1l4.678,1.972,2.161-5.124-4.477-1.888a12.42,12.42,0,0,0,.159-4.321l4.369-1.776-2.1-5.152-4.219,1.716a12.473,12.473,0,0,0-3.525-3.531l1.888-4.476-5.125-2.161-1.972,4.678a12.419,12.419,0,0,0-3.383,0l-2.022-4.975-5.152,2.095,1.964,4.826a12.474,12.474,0,0,0-3.531,3.525l-4.476-1.888-2.161,5.125,4.676,1.972a12.467,12.467,0,0,0,.1,4.05l-4.826,1.963,2.095,5.151Zm5.343-9.419a5.1,5.1,0,1,1,2.716,6.677,5.1,5.1,0,0,1-2.716-6.677",
    transform: "translate(92.722 56.991)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6459",
    "data-name": "Groupe 6459",
    transform: "translate(435.612 267.745)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6458",
    "data-name": "Groupe 6458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6457",
    "data-name": "Groupe 6457",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5726",
    "data-name": "Trac\\xE9 5726",
    d: "M349.96,235.549a12.433,12.433,0,0,0,2.36,2.424l-1.972,4.676,5.124,2.161,1.888-4.477a12.316,12.316,0,0,0,3.645.239l2.142,5.265,5.152-2.095-1.976-4.855a12.458,12.458,0,0,0,3.538-3.1l4.678,1.972,2.161-5.124-4.477-1.888a12.42,12.42,0,0,0,.159-4.321l4.369-1.776-2.1-5.152-4.219,1.716a12.473,12.473,0,0,0-3.525-3.531l1.888-4.476-5.125-2.161-1.972,4.678a12.419,12.419,0,0,0-3.383,0l-2.022-4.975-5.152,2.095,1.964,4.826a12.474,12.474,0,0,0-3.531,3.525l-4.476-1.888-2.161,5.125,4.676,1.972a12.467,12.467,0,0,0,.1,4.05l-4.826,1.963,2.095,5.151Zm5.343-9.419a5.1,5.1,0,1,1,2.716,6.677,5.1,5.1,0,0,1-2.716-6.677",
    transform: "translate(-342.89 -210.754)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5727",
    "data-name": "Trac\\xE9 5727",
    d: "M119.988,79.243a12.427,12.427,0,0,0,2.36,2.424l-1.972,4.676L125.5,88.5l1.888-4.477a12.318,12.318,0,0,0,3.645.239l2.142,5.265,5.152-2.095-1.975-4.856a12.456,12.456,0,0,0,3.538-3.1l4.676,1.972,2.162-5.124-4.477-1.888a12.42,12.42,0,0,0,.159-4.321l4.368-1.776L144.682,63.2l-4.219,1.716a12.473,12.473,0,0,0-3.525-3.531l1.888-4.476L133.7,54.745l-1.972,4.678a12.415,12.415,0,0,0-3.383,0l-2.022-4.975-5.152,2.095,1.964,4.826a12.473,12.473,0,0,0-3.53,3.525l-4.476-1.888-2.161,5.125,4.676,1.972a12.466,12.466,0,0,0,.1,4.05l-4.826,1.963,2.095,5.152Zm5.343-9.419a5.1,5.1,0,1,1,2.716,6.677,5.1,5.1,0,0,1-2.716-6.677",
    transform: "translate(30.535 14.724)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6462",
    "data-name": "Groupe 6462",
    transform: "translate(143.453 69.171)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6461",
    "data-name": "Groupe 6461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6460",
    "data-name": "Groupe 6460",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5728",
    "data-name": "Trac\\xE9 5728",
    d: "M119.988,79.243a12.427,12.427,0,0,0,2.36,2.424l-1.972,4.676L125.5,88.5l1.888-4.477a12.318,12.318,0,0,0,3.645.239l2.142,5.265,5.152-2.095-1.975-4.856a12.456,12.456,0,0,0,3.538-3.1l4.676,1.972,2.162-5.124-4.477-1.888a12.42,12.42,0,0,0,.159-4.321l4.368-1.776L144.682,63.2l-4.219,1.716a12.473,12.473,0,0,0-3.525-3.531l1.888-4.476L133.7,54.745l-1.972,4.678a12.415,12.415,0,0,0-3.383,0l-2.022-4.975-5.152,2.095,1.964,4.826a12.473,12.473,0,0,0-3.53,3.525l-4.476-1.888-2.161,5.125,4.676,1.972a12.466,12.466,0,0,0,.1,4.05l-4.826,1.963,2.095,5.152Zm5.343-9.419a5.1,5.1,0,1,1,2.716,6.677,5.1,5.1,0,0,1-2.716-6.677",
    transform: "translate(-112.918 -54.448)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6472",
    "data-name": "Groupe 6472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6471",
    "data-name": "Groupe 6471",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5729",
    "data-name": "Trac\\xE9 5729",
    d: "M286.161,86.935v43.474l-130.421.01V.008h11.746s8.02,2.284,10.678,8.648c2.382,5.666-1.178,12.5-2,13.942-.069.127-.108.206-.137.245-.01,0-.01.019-.01.029H176a19.81,19.81,0,1,0,34.267,0c0-.01-.01-.029-.01-.039a.731.731,0,0,1-.137-.235c-.823-1.441-4.392-8.275-2.02-13.942C210.773,2.292,218.784.008,218.784.008H286.15l.01,35.629s-2.294,8.011-8.658,10.688c-5.657,2.382-12.5-1.2-13.942-2a1.963,1.963,0,0,0-.245-.137c0-.019-.01-.019-.029-.029a19.6,19.6,0,0,0-9.942-2.667,19.8,19.8,0,1,0,9.942,36.933.047.047,0,0,1,.039-.019c.048-.02.117-.079.235-.147,1.441-.814,8.284-4.393,13.942-2,6.364,2.667,8.658,10.677,8.658,10.677",
    transform: "translate(42.114 0.002)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6467",
    "data-name": "Groupe 6467",
    transform: "translate(197.854 0.009)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6466",
    "data-name": "Groupe 6466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6465",
    "data-name": "Groupe 6465",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5730",
    "data-name": "Trac\\xE9 5730",
    d: "M286.161,86.935v43.474l-130.421.01V.008h11.746s8.02,2.284,10.678,8.648c2.382,5.666-1.178,12.5-2,13.942-.069.127-.108.206-.137.245-.01,0-.01.019-.01.029H176a19.81,19.81,0,1,0,34.267,0c0-.01-.01-.029-.01-.039a.731.731,0,0,1-.137-.235c-.823-1.441-4.392-8.275-2.02-13.942C210.773,2.292,218.784.008,218.784.008H286.15l.01,35.629s-2.294,8.011-8.658,10.688c-5.657,2.382-12.5-1.2-13.942-2a1.963,1.963,0,0,0-.245-.137c0-.019-.01-.019-.029-.029a19.6,19.6,0,0,0-9.942-2.667,19.8,19.8,0,1,0,9.942,36.933.047.047,0,0,1,.039-.019c.048-.02.117-.079.235-.147,1.441-.814,8.284-4.393,13.942-2,6.364,2.667,8.658,10.677,8.658,10.677",
    transform: "translate(-155.74 -0.007)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5731",
    "data-name": "Trac\\xE9 5731",
    d: "M399.879,0V130.283H382.5c-1.314-.432-8.051-2.853-10.452-8.57-2.383-5.657,1.185-12.491,2-13.931a2.692,2.692,0,0,1,.147-.235c0-.01.01-.02.01-.031l.009-.009a19.783,19.783,0,1,0-34.238.009c.01.01.01.02.02.031a2.62,2.62,0,0,1,.147.235c.813,1.441,4.373,8.274,2,13.931-2.4,5.717-9.138,8.138-10.452,8.57h-62.1V86.858s-2.285-8.01-8.639-10.677c-5.657-2.373-12.491,1.187-13.931,2a2.637,2.637,0,0,0-.235.147c-.01.01-.02.01-.031.019a19.789,19.789,0,1,1-.009-34.236l.009.009c.01,0,.02.01.031.01a2.634,2.634,0,0,0,.235.147c1.441.813,8.274,4.383,13.931,2,6.353-2.667,8.639-10.677,8.639-10.677V0Z",
    transform: "translate(58.689)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6470",
    "data-name": "Groupe 6470",
    transform: "translate(275.722)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6469",
    "data-name": "Groupe 6469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6468",
    "data-name": "Groupe 6468",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5732",
    "data-name": "Trac\\xE9 5732",
    d: "M399.879,0V130.283H382.5c-1.314-.432-8.051-2.853-10.452-8.57-2.383-5.657,1.185-12.491,2-13.931a2.692,2.692,0,0,1,.147-.235c0-.01.01-.02.01-.031l.009-.009a19.783,19.783,0,1,0-34.238.009c.01.01.01.02.02.031a2.62,2.62,0,0,1,.147.235c.813,1.441,4.373,8.274,2,13.931-2.4,5.717-9.138,8.138-10.452,8.57h-62.1V86.858s-2.285-8.01-8.639-10.677c-5.657-2.373-12.491,1.187-13.931,2a2.637,2.637,0,0,0-.235.147c-.01.01-.02.01-.031.019a19.789,19.789,0,1,1-.009-34.236l.009.009c.01,0,.02.01.031.01a2.634,2.634,0,0,0,.235.147c1.441.813,8.274,4.383,13.931,2,6.353-2.667,8.639-10.677,8.639-10.677V0Z",
    transform: "translate(-217.033)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6498",
    "data-name": "Groupe 6498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6497",
    "data-name": "Groupe 6497",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5733",
    "data-name": "Trac\\xE9 5733",
    d: "M302.8,113.64l-9.7,23.223c-1.629,3.844-3.29,7.666-4.975,11.408-.837,1.865-1.707,3.708-2.578,5.483s-1.765,3.516-2.612,4.941a13,13,0,0,1-.746,1.165l-.011.011-1.255.6-1.38.622-2.827,1.232-11.634,4.929c-7.812,3.313-15.636,6.728-23.381,10.335l2.735,8.524c8.446-1.606,16.79-3.494,25.112-5.608,4.149-1.1,8.3-2.171,12.47-3.426l3.166-.96,1.606-.509,1.707-.588.644-.236.293-.124,1.165-.509c.215-.1.362-.158.611-.282.248-.147.485-.283.711-.441s.475-.318.611-.419a14.9,14.9,0,0,0,1.549-1.357c.509-.52.927-.995,1.289-1.436.69-.826,1.186-1.537,1.7-2.25.859-1.244,1.6-2.442,2.306-3.607.521-.847.995-1.673,1.47-2.5,1.108-1.989,2.148-3.957,3.154-5.913,2.024-3.924,3.867-7.859,5.676-11.793,3.584-7.892,6.92-15.761,9.961-23.89Zm-20.092,45.971-.067.046-.046.022.113-.079a.453.453,0,0,1,.1-.056c-.034.022-.067.044-.1.067",
    transform: "translate(65.36 30.73)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5734",
    "data-name": "Trac\\xE9 5734",
    d: "M247.741,165.435s-2.341-2.505-5.176-2.569-5.082-.866-7.193-.769.132,1.861,1.516,2.556,2.944,1.5,2.252,2.452-9.923,5.121-10.73,6.553.9,1.225.9,1.225-2.063.949-2.03,2.066,1.509.908,1.509.908-1.363.686-.769,1.592,8.549-1.27,8.963-1.175c0,0-4.713.272-4.923,1.653s2.844.927,5.286.616a10.941,10.941,0,0,0,6.624-3.271c1.7-1.853,5.52-4.073,5.074-6.943a22.794,22.794,0,0,0-1.3-4.894",
    transform: "translate(61.459 43.831)",
    fill: "#ce7a63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6475",
    "data-name": "Groupe 6475",
    transform: "translate(290.31 214.085)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6474",
    "data-name": "Groupe 6474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6473",
    "data-name": "Groupe 6473",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5735",
    "data-name": "Trac\\xE9 5735",
    d: "M228.846,176.194q3.546-1.6,7.175-2.954a14.127,14.127,0,0,0,.9,1.814c.179.286.542-.085.38-.371a14.44,14.44,0,0,1-1.887-5.956c-.036-.351-.5-.235-.462.117a14.135,14.135,0,0,0,.239,1.58.163.163,0,0,0-.136-.006,25.207,25.207,0,0,0-5.614,2.379c-.271.163-.09.657.2.494a24.7,24.7,0,0,1,5.487-2.331.256.256,0,0,0,.151-.137,13.878,13.878,0,0,0,.562,1.93q-3.621,1.341-7.175,2.955c-.287.13-.1.616.188.485",
    transform: "translate(-228.516 -168.516)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6478",
    "data-name": "Groupe 6478",
    transform: "translate(299.264 212.916)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6477",
    "data-name": "Groupe 6477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6476",
    "data-name": "Groupe 6476",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5736",
    "data-name": "Trac\\xE9 5736",
    d: "M236,170.974a6.141,6.141,0,0,1,7.156-2.466c.288.109.468-.413.179-.522-2.776-1.029-5.732.015-7.714,2.679-.2.282.182.574.379.309",
    transform: "translate(-235.564 -167.596)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6481",
    "data-name": "Groupe 6481",
    transform: "translate(388.275 146.362)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6480",
    "data-name": "Groupe 6480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6479",
    "data-name": "Groupe 6479",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5737",
    "data-name": "Trac\\xE9 5737",
    d: "M307.362,116.074a.867.867,0,1,1-.866-.866.867.867,0,0,1,.866.866",
    transform: "translate(-305.629 -115.208)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6484",
    "data-name": "Groupe 6484",
    transform: "translate(388.275 152.038)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6483",
    "data-name": "Groupe 6483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6482",
    "data-name": "Groupe 6482",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5738",
    "data-name": "Trac\\xE9 5738",
    d: "M307.362,120.543a.867.867,0,1,1-.866-.866.867.867,0,0,1,.866.866",
    transform: "translate(-305.629 -119.676)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6487",
    "data-name": "Groupe 6487",
    transform: "translate(388.275 157.716)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6486",
    "data-name": "Groupe 6486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6485",
    "data-name": "Groupe 6485",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5739",
    "data-name": "Trac\\xE9 5739",
    d: "M307.362,125.011a.867.867,0,1,1-.866-.866.867.867,0,0,1,.866.866",
    transform: "translate(-305.629 -124.145)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5740",
    "data-name": "Trac\\xE9 5740",
    d: "M292.555,342.715l-3.242,13.343h-7.025l-.32-13.343Z",
    transform: "translate(76.248 92.675)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5741",
    "data-name": "Trac\\xE9 5741",
    d: "M266.159,363.333c.381-4.347,2.291-5.646,4.648-5.794,2.453-.154,11.21-3.086,11.21-3.086s1.83-2.761,3.442-3.322,3.171,1.082,3.171,1.082l4.411-.539s1.322-1.984,2.232-.245c1.409,2.695,1.239,10.154,1.108,11.9Z",
    transform: "translate(71.973 94.838)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5742",
    "data-name": "Trac\\xE9 5742",
    d: "M266.665,361.33l5.479-.025q11.986-.057,23.97-.125c.306,0,.242-.466-.061-.459-.538.005-1.085,0-1.624.009a.159.159,0,0,0-.025-.062,4.441,4.441,0,0,1,1.634-6.318c.25-.14-.046-.547-.286-.4a4.838,4.838,0,0,0-1.806,6.776c-1.129.011-2.251.015-3.381.018q-11.973.059-23.961.126c-.3,0-.243.466.061.459",
    transform: "translate(72.039 95.705)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5743",
    "data-name": "Trac\\xE9 5743",
    d: "M321.888,214.172c-1.429,13.445-4.239,30.839-9.327,53.224q-2.216,9.757-5.039,20.811c5.172,42.71-15.068,104.414-15.068,104.414l-10.842-.243s-1.359-68.956-.085-105.056c2.09-59.148,9.294-115.491,9.294-115.491l29.528-.116s5.1,8.89,1.539,42.456",
    transform: "translate(75.981 46.434)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6490",
    "data-name": "Groupe 6490",
    transform: "translate(386.669 239.688)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6489",
    "data-name": "Groupe 6489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6488",
    "data-name": "Groupe 6488",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5744",
    "data-name": "Trac\\xE9 5744",
    d: "M315.565,209.588c-1.429,13.445-4.239,30.839-9.328,53.224-6.214-23.656,5.027-74.143,5.027-74.143Z",
    transform: "translate(-304.365 -188.669)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5745",
    "data-name": "Trac\\xE9 5745",
    d: "M280.572,348.406l-.343-4.643h14.462l-.818,4.643Z",
    transform: "translate(75.778 92.958)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5746",
    "data-name": "Trac\\xE9 5746",
    d: "M327.936,342.715l-3.242,13.343h-7.025l-.32-13.343Z",
    transform: "translate(85.815 92.675)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5747",
    "data-name": "Trac\\xE9 5747",
    d: "M301.54,363.333c.381-4.347,2.291-5.646,4.648-5.794,2.453-.154,11.21-3.086,11.21-3.086s1.829-2.761,3.441-3.322,3.171,1.082,3.171,1.082l4.411-.539s1.323-1.984,2.232-.245c1.409,2.695,1.239,10.154,1.108,11.9Z",
    transform: "translate(81.541 94.838)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5748",
    "data-name": "Trac\\xE9 5748",
    d: "M302.047,361.33l5.479-.025q11.986-.057,23.97-.125c.3,0,.243-.466-.061-.459-.537.005-1.086,0-1.624.009a.181.181,0,0,0-.026-.062,4.441,4.441,0,0,1,1.634-6.318c.25-.14-.047-.547-.287-.4a4.838,4.838,0,0,0-1.805,6.776c-1.129.011-2.251.015-3.382.018q-11.971.059-23.96.126c-.306,0-.244.466.061.459",
    transform: "translate(81.607 95.705)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5749",
    "data-name": "Trac\\xE9 5749",
    d: "M305.177,173.864s5.521,81.647,7.326,114.1c2.061,37.072,6.7,100.264,7.329,104.4h11.2c-1.283,1.25,14.382-55.47,8.066-101.65,5.92-44.171,13.123-76.512,3.837-118.1Z",
    transform: "translate(82.524 46.677)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5750",
    "data-name": "Trac\\xE9 5750",
    d: "M315.746,348.406l-.343-4.643h14.462l-.818,4.643Z",
    transform: "translate(85.289 92.958)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5751",
    "data-name": "Trac\\xE9 5751",
    d: "M351.369,194.05c-23.547,7.776-63.12,5.22-63.12-.169,0-15.19,5.378-32.27,3.937-42.166-11.133-7.788-2.435-14.826-3.4-26.37a17.107,17.107,0,0,1,14.2-18.205c2.011-.339,4.095-.678,6.141-.945.424-.06.836-.109,1.248-.158a124.356,124.356,0,0,1,16.462-.775c2.011,0,4.093.037,6.275.061s4.288.133,6.3.278a12.658,12.658,0,0,1,11.58,14.838,237.845,237.845,0,0,0-3.428,30.658c-.1,2.12-.17,4.167-.194,6.178a162.108,162.108,0,0,0,.957,21.076c.013.133.037.267.048.387q.509,4.179,1.236,7.7c.145.739.3,1.442.473,2.132.339,1.466.908,4.022,1.3,5.475",
    transform: "translate(77.462 28.463)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6493",
    "data-name": "Groupe 6493",
    transform: "translate(413.913 152.254)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6492",
    "data-name": "Groupe 6492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6491",
    "data-name": "Groupe 6491",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5752",
    "data-name": "Trac\\xE9 5752",
    d: "M325.81,119.846l11.747,17.694c.18-2.125.4-4.3.656-6.489v-.046Z",
    transform: "translate(-325.81 -119.846)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5753",
    "data-name": "Trac\\xE9 5753",
    d: "M304.616,121.321a.755.755,0,1,1-.755-.755.755.755,0,0,1,.755.755",
    transform: "translate(81.964 32.603)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5754",
    "data-name": "Trac\\xE9 5754",
    d: "M304.256,126.665a.755.755,0,1,1-.755-.755.755.755,0,0,1,.755.755",
    transform: "translate(81.866 34.048)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5755",
    "data-name": "Trac\\xE9 5755",
    d: "M304.256,132.1a.755.755,0,1,1-.755-.755.755.755,0,0,1,.755.755",
    transform: "translate(81.866 35.518)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5756",
    "data-name": "Trac\\xE9 5756",
    d: "M322.438,105.262c-5.576,9.8-18.694,15.667-18.694,15.667-1.771-4.392-1.216-11.431.985-14.734.424-.06.836-.109,1.249-.158a124.326,124.326,0,0,1,16.461-.775",
    transform: "translate(81.852 28.463)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5757",
    "data-name": "Trac\\xE9 5757",
    d: "M313.162,75s10.05,9.611,5.417,20.5a20.284,20.284,0,0,1-10.866,11.064Z",
    transform: "translate(83.21 20.28)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5758",
    "data-name": "Trac\\xE9 5758",
    d: "M302.162,73.134s-9.872-1.659-11.99,9.223S288.586,97.2,291.461,99.9c3.779,3.553,9.795-.316,9.795-.316Z",
    transform: "translate(78.118 19.752)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5759",
    "data-name": "Trac\\xE9 5759",
    d: "M304.376,112.8a1.9,1.9,0,0,1-.206.447c-1.9,2.992.165,5.723,3.429,5.488a7.575,7.575,0,0,0,.935-.127,5.726,5.726,0,0,0,3.07-1.716l.01-.011a71.788,71.788,0,0,1,8.118-7.461c-4.9-2.629-6.7-11.965-7.154-17.8l-7.614,9.695-1.425,2.118a17.03,17.03,0,0,1,1.65,3.744,6.037,6.037,0,0,1-.814,5.623",
    transform: "translate(82.056 24.775)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5760",
    "data-name": "Trac\\xE9 5760",
    d: "M318.958,105.369s4.561-1.187,8.152,0l-7.4,12.712c-3.895-2.839-8.358.846-16.193,2.96a40.783,40.783,0,0,0,15.439-15.672",
    transform: "translate(82.076 28.351)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5761",
    "data-name": "Trac\\xE9 5761",
    d: "M318.958,105.369s4.561-1.187,8.152,0l-7.4,12.712c-3.895-2.839-8.358.846-16.193,2.96a40.783,40.783,0,0,0,15.439-15.672",
    transform: "translate(82.076 28.351)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5762",
    "data-name": "Trac\\xE9 5762",
    d: "M307.051,105.748s-4.519-.828-7.14,1.3a70.254,70.254,0,0,0-2.117,10s4.349-2.171,7.272,3.785c0,0-1.479-9.487,1.984-15.09",
    transform: "translate(80.528 28.553)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5763",
    "data-name": "Trac\\xE9 5763",
    d: "M307.051,105.748s-4.519-.828-7.14,1.3a70.254,70.254,0,0,0-2.117,10s4.349-2.171,7.272,3.785c0,0-1.479-9.487,1.984-15.09",
    transform: "translate(80.528 28.553)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6496",
    "data-name": "Groupe 6496",
    transform: "translate(385.595 126.09)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6495",
    "data-name": "Groupe 6495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6494",
    "data-name": "Groupe 6494",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5764",
    "data-name": "Trac\\xE9 5764",
    d: "M305.171,105.111a16.976,16.976,0,0,0-1.652-3.744l1.425-2.117,4.8.109a11.345,11.345,0,0,1-4.57,5.751",
    transform: "translate(-303.519 -99.251)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5765",
    "data-name": "Trac\\xE9 5765",
    d: "M317.325,86.057c.762,9.584,1.287,13.625-2.735,19.164-6.05,8.333-17.766,7.127-21.323-2.047-3.2-8.258-3.91-22.544,4.681-27.607,8.465-4.989,18.613.906,19.376,10.49",
    transform: "translate(78.705 19.944)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5766",
    "data-name": "Trac\\xE9 5766",
    d: "M310.967,89.7c4.8-1.278,2.917-6.242,2.917-6.242l-7.077,1.1s-.644,6.41,4.161,5.144",
    transform: "translate(82.957 22.57)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5767",
    "data-name": "Trac\\xE9 5767",
    d: "M294.029,76.926s1.108,5.29,7.608,5.573,5.932,9.891,13.212,8.373S319.971,78.2,316.862,75.8s-15.6-7.622-22.833,1.131",
    transform: "translate(79.509 19.483)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5768",
    "data-name": "Trac\\xE9 5768",
    d: "M305.967,74.12s4.731-13.983,15.71-8.448,1.339,19.9-5.623,18.031-10.087-9.583-10.087-9.583",
    transform: "translate(82.738 17.408)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5769",
    "data-name": "Trac\\xE9 5769",
    d: "M295.941,95.947a32.538,32.538,0,0,0,5.7-4.144s.685,3.636-1.761,4.976a2.953,2.953,0,0,1-3.935-.832",
    transform: "translate(80.027 24.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5770",
    "data-name": "Trac\\xE9 5770",
    d: "M299.712,87.074c.109.774-.213,1.458-.719,1.53s-1-.5-1.113-1.272.213-1.458.719-1.531,1,.5,1.113,1.273",
    transform: "translate(80.545 23.2)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5771",
    "data-name": "Trac\\xE9 5771",
    d: "M293.523,88.081c.109.774-.213,1.458-.719,1.53s-1-.5-1.113-1.272.213-1.458.72-1.53,1,.5,1.112,1.272",
    transform: "translate(78.872 23.473)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5772",
    "data-name": "Trac\\xE9 5772",
    d: "M292.846,86.874l-1.934-.274s1.157,1.317,1.934.274",
    transform: "translate(78.667 23.418)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5773",
    "data-name": "Trac\\xE9 5773",
    d: "M295.916,87.683s-1.045,2.238-2.244,4.222a1.172,1.172,0,0,0,.62,1.727,11.565,11.565,0,0,0,2.521.48Z",
    transform: "translate(79.366 23.711)",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5774",
    "data-name": "Trac\\xE9 5774",
    d: "M316.494,89.3a6.172,6.172,0,0,1-3.273,3.88c-2.029.887-3.4-1.282-3.142-3.717.236-2.19,1.578-5.293,3.759-5.13,2.151.159,3.335,2.752,2.655,4.967",
    transform: "translate(83.841 22.804)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5775",
    "data-name": "Trac\\xE9 5775",
    d: "M301.828,84.852a.458.458,0,0,1-.332-.144,3.661,3.661,0,0,0-3.09-1.206.459.459,0,1,1-.163-.9,4.556,4.556,0,0,1,3.919,1.479.459.459,0,0,1-.335.774",
    transform: "translate(80.547 22.326)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5776",
    "data-name": "Trac\\xE9 5776",
    d: "M290.4,86a.459.459,0,0,1-.4-.744,4.555,4.555,0,0,1,3.792-1.782.459.459,0,0,1-.09.913,3.634,3.634,0,0,0-2.985,1.444A.458.458,0,0,1,290.4,86",
    transform: "translate(78.392 22.57)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5777",
    "data-name": "Trac\\xE9 5777",
    d: "M299.035,85.868l-1.934-.274s1.157,1.317,1.934.274",
    transform: "translate(80.34 23.146)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_1",
    "data-name": "Ligne 1",
    x1: 7.066,
    y2: 1.099,
    transform: "translate(389.769 106.034)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5778",
    "data-name": "Trac\\xE9 5778",
    d: "M350.287,164.447c-3.946,6.332-8.344,12.7-12.652,18.972l6.659,5.992a180.963,180.963,0,0,0,16.745-17.05,91.677,91.677,0,0,0,7.576-9.984c.6-.938,1.187-1.911,1.752-3a25.423,25.423,0,0,0,1.617-3.72,15.751,15.751,0,0,0,.644-2.578,11.785,11.785,0,0,0,.034-3.946,14.6,14.6,0,0,0-1.029-3.358,22.437,22.437,0,0,0-1.04-2.092,48.355,48.355,0,0,0-4-5.834c-1.334-1.707-2.668-3.3-4.013-4.85-2.736-3.053-5.472-5.981-8.31-8.785-5.642-5.63-11.4-10.923-17.581-15.988l-11.748,13.76,16.914,15.218c2.77,2.568,5.552,5.077,8.141,7.666,1.311,1.267,2.589,2.545,3.764,3.811a41.069,41.069,0,0,1,2.94,3.459c.011.023.034.034.046.057-.079.215-.159.451-.249.689-.26.668-.577,1.4-.916,2.16a101.591,101.591,0,0,1-5.291,9.4",
    transform: "translate(87.868 29.267)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5779",
    "data-name": "Trac\\xE9 5779",
    d: "M337.153,165.207s-7.512,2.786-8.671,4.25,6.216,9.767,9.078,10.929,1.389-2.286,1.389-2.286,3.7.863,5.423-1.944-.311-10.481-7.22-10.95",
    transform: "translate(88.793 44.674)",
    fill: "#ff8b7b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5780",
    "data-name": "Trac\\xE9 5780",
    d: "M193.3,337.779v19.642l7.934.633,3.885-18.391Z",
    transform: "translate(52.271 91.34)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6536",
    "data-name": "Groupe 6536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6535",
    "data-name": "Groupe 6535",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5781",
    "data-name": "Trac\\xE9 5781",
    d: "M199.157,353.2s2.494-4.789,3.966-4.277,2.072,6.32,2.072,6.32,8,2.674,10.229,2.815,4.042,1.406,4.33,5.769h-27.3s.185-9.851.234-11.54,2.454.423,2.454.423Z",
    transform: "translate(52.041 94.343)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5782",
    "data-name": "Trac\\xE9 5782",
    d: "M192.707,354.6a4.1,4.1,0,0,1,1.484,5.758.205.205,0,1,0,.347.218,4.5,4.5,0,0,0-1.565-6.351c-.225-.137-.493.238-.266.375",
    transform: "translate(52.087 95.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5783",
    "data-name": "Trac\\xE9 5783",
    d: "M192.7,359.5l21.418.224,4.979.052c.279,0,.335-.431.056-.433q-10.709-.112-21.418-.224l-4.979-.052c-.28,0-.334.431-.056.433",
    transform: "translate(52.058 97.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5784",
    "data-name": "Trac\\xE9 5784",
    d: "M201.638,355.606c1.122-1.336,2.754-1.711,3.983-.705.2.167.468-.209.267-.373-1.408-1.154-3.323-.656-4.6.86-.191.227.158.445.347.219",
    transform: "translate(54.417 95.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5785",
    "data-name": "Trac\\xE9 5785",
    d: "M203.418,356.165c1.122-1.336,2.754-1.711,3.983-.705.2.167.468-.209.267-.373-1.408-1.154-3.323-.656-4.6.86-.191.227.157.445.347.218",
    transform: "translate(54.898 95.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5786",
    "data-name": "Trac\\xE9 5786",
    d: "M205.259,356.724c1.122-1.336,2.753-1.711,3.983-.7.2.166.468-.21.267-.374-1.408-1.154-3.323-.657-4.6.86-.19.227.158.445.347.219",
    transform: "translate(55.396 96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5787",
    "data-name": "Trac\\xE9 5787",
    d: "M189.55,184.545c.226,3.505-.255,14.268.22,20.046.893,11.012,2.092,25.293,3.041,39.595,1.108,16.564,1.9,33.15,1.5,44.66-1.018,29.555-.791,96.535-.791,96.535h12.821s15.061-66.572,17.876-96.535c2.352-24.84,1.1-88.834.709-104.3Z",
    transform: "translate(51.257 49.904)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6501",
    "data-name": "Groupe 6501",
    transform: "translate(240.807 234.449)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6500",
    "data-name": "Groupe 6500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6499",
    "data-name": "Groupe 6499",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5788",
    "data-name": "Trac\\xE9 5788",
    d: "M189.55,184.545c.226,3.505-.255,14.268.22,20.046.893,11.012,2.092,25.293,3.041,39.595,1.108,16.564,1.9,33.15,1.5,44.66-1.018,29.555-.791,96.535-.791,96.535h12.821s15.061-66.572,17.876-96.535c2.352-24.84,1.1-88.834.709-104.3Z",
    transform: "translate(-189.55 -184.545)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6504",
    "data-name": "Groupe 6504",
    transform: "translate(241.027 247.189)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6503",
    "data-name": "Groupe 6503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6502",
    "data-name": "Groupe 6502",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5789",
    "data-name": "Trac\\xE9 5789",
    d: "M189.723,201.879c.893,11.012,2.091,25.293,3.041,39.595,6.309-18.678.452-46.9.452-46.9Z",
    transform: "translate(-189.723 -194.574)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5790",
    "data-name": "Trac\\xE9 5790",
    d: "M191.884,344.054H206.93l1.1-4.8-16.542-.2Z",
    transform: "translate(51.782 91.685)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5791",
    "data-name": "Trac\\xE9 5791",
    d: "M142.345,334.9l-3,19.412,7.744,1.836,6.646-17.583Z",
    transform: "translate(37.681 90.56)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5792",
    "data-name": "Trac\\xE9 5792",
    d: "M145.628,350.694s3.2-4.352,4.574-3.622,1.082,6.562,1.082,6.562,7.494,3.863,9.679,4.344,3.781,2.009,3.4,6.364l-26.984-4.167s1.687-9.708,1.993-11.37,2.36.792,2.36.792Z",
    transform: "translate(37.149 93.831)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5793",
    "data-name": "Trac\\xE9 5793",
    d: "M138.563,351.417a4.1,4.1,0,0,1,.588,5.916.205.205,0,1,0,.309.269,4.5,4.5,0,0,0-.576-6.515c-.2-.17-.523.159-.321.329",
    transform: "translate(37.452 94.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5794",
    "data-name": "Trac\\xE9 5794",
    d: "M137.8,356.268l21.132,3.491,4.914.811c.274.046.4-.375.121-.419l-21.132-3.491-4.914-.811c-.274-.046-.4.373-.121.419",
    transform: "translate(37.221 96.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5795",
    "data-name": "Trac\\xE9 5795",
    d: "M147.279,353.7c1.312-1.15,2.983-1.272,4.044-.089.175.2.494-.136.322-.329-1.216-1.354-3.185-1.155-4.674.149-.224.2.088.464.309.269",
    transform: "translate(39.722 95.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5796",
    "data-name": "Trac\\xE9 5796",
    d: "M148.954,354.523c1.311-1.15,2.982-1.272,4.044-.088.175.194.493-.137.32-.33-1.216-1.354-3.185-1.155-4.674.149-.224.2.088.464.31.269",
    transform: "translate(40.175 95.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5797",
    "data-name": "Trac\\xE9 5797",
    d: "M150.687,355.356c1.312-1.15,2.983-1.272,4.044-.089.175.2.494-.136.321-.329-1.216-1.354-3.185-1.155-4.674.149-.224.2.088.464.309.269",
    transform: "translate(40.644 95.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5798",
    "data-name": "Trac\\xE9 5798",
    d: "M187.3,291.8c-7.924,29.026-34.562,91.809-34.562,91.809l-12.634-2.2s13.158-65.322,19.224-94.258c5.473-26.115,11.483-86.1,13.424-103.955l42.405,3.818c-2.26,15.3-21.283,80.709-27.858,104.788",
    transform: "translate(37.885 49.538)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6507",
    "data-name": "Groupe 6507",
    transform: "translate(177.986 232.732)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6506",
    "data-name": "Groupe 6506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6505",
    "data-name": "Groupe 6505",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5799",
    "data-name": "Trac\\xE9 5799",
    d: "M187.3,291.8c-7.924,29.026-34.562,91.809-34.562,91.809l-12.634-2.2s13.158-65.322,19.224-94.258c5.473-26.115,11.483-86.1,13.424-103.955l42.405,3.818c-2.26,15.3-21.283,80.709-27.858,104.788",
    transform: "translate(-140.101 -183.194)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5800",
    "data-name": "Trac\\xE9 5800",
    d: "M139.177,340.483,154,343.064l1.911-4.539-16.519-3.016Z",
    transform: "translate(37.635 90.726)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5801",
    "data-name": "Trac\\xE9 5801",
    d: "M238.193,118.6c-.713,6.128-1.876,19.074-3.018,33.67-.419,5.519-.849,11.3-1.232,17.017-.464,6.614-.837,12.968-1.131,18.745-.113,2.341-.215,4.591-.306,6.717-.407,10.527-.407,18.214.182,20.532-32.822,13.285-68.471-3.89-68.471-3.89,2.114-17.185,4.239-36.711,4.239-36.711.995-7.315,1.968-14.71,2.827-21.675.069-.565.147-1.131.2-1.685.418-3.426.8-6.728,1.153-9.86.046-.384.09-.769.136-1.154.678-6.161,1.2-11.612,1.514-15.975.588-8.208,5.575-15.851,13-17.219,2.25-.419,4.681-.791,7.191-1.075.6-.079,1.211-.135,1.821-.2a156.265,156.265,0,0,1,21.381-.87c.339,0,.69.011,1.029.023.169.011.372.011.542.022.294.011.6.023.893.046a82.62,82.62,0,0,1,8.469.78,11.329,11.329,0,0,1,9.576,12.765",
    transform: "translate(44.406 28.366)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6510",
    "data-name": "Groupe 6510",
    transform: "translate(258.289 150.233)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6509",
    "data-name": "Groupe 6509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6508",
    "data-name": "Groupe 6508",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5802",
    "data-name": "Trac\\xE9 5802",
    d: "M205.4,119.266a1.046,1.046,0,1,1-1.08-1.01,1.046,1.046,0,0,1,1.08,1.01",
    transform: "translate(-203.311 -118.255)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6513",
    "data-name": "Groupe 6513",
    transform: "translate(258.506 156.736)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6512",
    "data-name": "Groupe 6512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6511",
    "data-name": "Groupe 6511",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5803",
    "data-name": "Trac\\xE9 5803",
    d: "M205.573,124.385a1.046,1.046,0,1,1-1.08-1.01,1.046,1.046,0,0,1,1.08,1.01",
    transform: "translate(-203.482 -123.374)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6516",
    "data-name": "Groupe 6516",
    transform: "translate(258.725 163.239)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6515",
    "data-name": "Groupe 6515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6514",
    "data-name": "Groupe 6514",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5804",
    "data-name": "Trac\\xE9 5804",
    d: "M205.745,129.5a1.046,1.046,0,1,1-1.08-1.01,1.046,1.046,0,0,1,1.08,1.01",
    transform: "translate(-203.654 -128.493)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6519",
    "data-name": "Groupe 6519",
    transform: "translate(236.65 164.719)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6518",
    "data-name": "Groupe 6518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6517",
    "data-name": "Groupe 6517",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5805",
    "data-name": "Trac\\xE9 5805",
    d: "M190.435,129.658s1.236,28.315,3.461,30.487,28.785,12.872,28.785,12.872c-15.222-1.761-28.849-4.155-35.555-9.3-2.481-6.844,1.052-21.254,3.309-34.061",
    transform: "translate(-186.278 -129.658)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6522",
    "data-name": "Groupe 6522",
    transform: "translate(219.549 167.297)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6521",
    "data-name": "Groupe 6521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6520",
    "data-name": "Groupe 6520",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5806",
    "data-name": "Trac\\xE9 5806",
    d: "M230.485,180.791c-.113,2.34-.215,4.59-.3,6.715-9.384-.61-44.253-1.091-53.83-14.868-5.606-8.063-2.861-40.952-2.861-40.952a69.33,69.33,0,0,0,48.73,46.933Z",
    transform: "translate(-172.817 -131.687)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5807",
    "data-name": "Trac\\xE9 5807",
    d: "M272.79,149.068c-4.092-.249-8.185-.474-12.131-.836-1.945-.193-3.912-.4-5.575-.656-.259-.034-.531-.091-.78-.136a2.287,2.287,0,0,0-.328-.339c-.859-.814-2.16-2.183-3.346-3.562-1.221-1.4-2.453-2.917-3.686-4.454-2.477-3.064-4.919-6.287-7.372-9.509-4.885-6.468-9.8-13.116-14.755-19.515l-16.485,11.917c4.85,7.044,9.971,13.658,15.467,20.2,2.747,3.268,5.585,6.468,8.582,9.668,1.526,1.583,3.074,3.154,4.749,4.748a53.1,53.1,0,0,0,5.811,4.908,24.874,24.874,0,0,0,2.227,1.4l.758.407c.271.136.621.282.938.418s.8.306,1.209.441a3.851,3.851,0,0,0,.453.113l.384.09a25.413,25.413,0,0,0,4.511.555c2.476.123,4.67.067,6.874-.023,4.375-.193,8.6-.509,12.822-.939q7.75-.779,15.41-1.888l.046-.023,1.378-.621,1.255-.6.012-.011a12.75,12.75,0,0,0,.746-1.165c.849-1.424,1.742-3.166,2.612-4.941.69-1.4,1.38-2.85,2.047-4.319-7.959-.531-15.953-.893-23.834-1.334m-19.356-1.888s.011-.011.011,0a.191.191,0,0,1,.067.011c.159.034.408.136.487.158.034.011.09.034.136.046a1.956,1.956,0,0,1-.7-.215",
    transform: "translate(56.336 29.762)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6525",
    "data-name": "Groupe 6525",
    transform: "translate(279.875 155.764)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6524",
    "data-name": "Groupe 6524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6523",
    "data-name": "Groupe 6523",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5808",
    "data-name": "Trac\\xE9 5808",
    d: "M223.75,142.5l-2.861-19.888-.587,15.875Z",
    transform: "translate(-220.302 -122.609)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5809",
    "data-name": "Trac\\xE9 5809",
    d: "M211.7,70.423a18.032,18.032,0,0,0-14.266,1.74c-2.789,1.683-5.15,4.14-4.872,7.584.649,8.039,3.738,21.362,3.738,21.362l26.4-13.986s1.556-6.865-1.9-10.965a17.617,17.617,0,0,0-9.1-5.736",
    transform: "translate(52.064 18.845)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5810",
    "data-name": "Trac\\xE9 5810",
    d: "M201.711,70.238a11.944,11.944,0,0,0-8.8,3.834c-2.876,3.367.671,12.007.671,12.007Z",
    transform: "translate(51.861 18.993)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5811",
    "data-name": "Trac\\xE9 5811",
    d: "M197.495,71.8s1.006-3.548,11.779-3.539c10.672.008,17.342-.126,15.986,6.083-1.8,8.228-14.963,5.216-14.963,5.216Z",
    transform: "translate(53.405 18.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5812",
    "data-name": "Trac\\xE9 5812",
    d: "M208.864,104.763v.011c-.018.036-.025.058-.043.094l-1.429,4.56a15.13,15.13,0,0,0-.168,2.79,15.9,15.9,0,0,0,.239,2.249c.952,1.437,1.289,4.614-2.316,4.465-4.552-.18-12.665-6.8-12.873-8.815,2.387-6.125,4.546-13.732,4.474-19.69l4.939,5.853Z",
    transform: "translate(51.994 24.452)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6528",
    "data-name": "Groupe 6528",
    transform: "translate(253.124 122.171)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6527",
    "data-name": "Groupe 6527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6526",
    "data-name": "Groupe 6526",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5813",
    "data-name": "Trac\\xE9 5813",
    d: "M206.937,103.316l-1.43,4.56c-2.787-1.429-5.641-4.366-6.184-7.428-.377-2.208.7-4.21,1.588-4.281Z",
    transform: "translate(-199.245 -96.166)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5814",
    "data-name": "Trac\\xE9 5814",
    d: "M220.154,100.623c-.314.992-.661,1.967-1.028,2.927-3.263,8.479-13.919,8.775-20.236,2.132-.009-.013-.008-.024-.019-.025a15.861,15.861,0,0,1-1.573-1.937c-3.947-5.713-2.7-9.909-1.627-19.517a13.171,13.171,0,0,1,20.153-9.816c7.855,4.915,7.5,16.327,4.331,26.238",
    transform: "translate(52.622 19.555)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5815",
    "data-name": "Trac\\xE9 5815",
    d: "M205.468,91.228a66.074,66.074,0,0,0,6.244,3.162,3.492,3.492,0,0,1-5.047.774c-1.974-1.334-1.2-3.936-1.2-3.936",
    transform: "translate(55.521 24.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5816",
    "data-name": "Trac\\xE9 5816",
    d: "M216.4,73.818c-4.454-3.293-13.654-4.341-17.581.03s-3.492,11.618-3.492,11.618a3.127,3.127,0,0,0,.833,2.129,2.248,2.248,0,0,1,.295.349l4.758.473c.254-1.963.814-5.552,2.125-5.82,2.457-.5.6-3.128,1.034-4.694,1.415-5.09,15.184-2.533,17.22,4.991,0,0-.739-5.784-5.192-9.077",
    transform: "translate(52.816 19.185)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5817",
    "data-name": "Trac\\xE9 5817",
    d: "M191.368,87.14a9.184,9.184,0,0,0,3.395,6.139c2.532,1.988,5.027.02,5.352-3.013.294-2.731-.672-7.056-3.708-7.859-2.993-.79-5.346,1.771-5.038,4.734",
    transform: "translate(51.741 22.245)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5818",
    "data-name": "Trac\\xE9 5818",
    d: "M206.679,85.837c-.13.738.158,1.406.64,1.49s.979-.446,1.108-1.185-.158-1.405-.64-1.49-.979.447-1.108,1.185",
    transform: "translate(55.88 22.889)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5819",
    "data-name": "Trac\\xE9 5819",
    d: "M212.825,86.887c-.13.738.158,1.406.64,1.49s.979-.446,1.108-1.185-.157-1.405-.64-1.49-.979.447-1.108,1.185",
    transform: "translate(57.542 23.173)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5820",
    "data-name": "Trac\\xE9 5820",
    d: "M216.037,85.241a.379.379,0,0,1-.295-.25,1.988,1.988,0,0,0-.995-1.222,2.306,2.306,0,0,0-1.578-.034.383.383,0,1,1-.272-.716,3.045,3.045,0,0,1,2.171.055,2.716,2.716,0,0,1,1.4,1.663.384.384,0,0,1-.234.49.392.392,0,0,1-.194.015",
    transform: "translate(57.504 22.401)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5821",
    "data-name": "Trac\\xE9 5821",
    d: "M205.339,83.4a.4.4,0,0,1-.172-.074.415.415,0,0,1-.093-.579,3.314,3.314,0,0,1,2-1.239,2.948,2.948,0,0,1,2.254.681.416.416,0,1,1-.5.661,2.157,2.157,0,0,0-1.622-.52,2.487,2.487,0,0,0-1.457.906.418.418,0,0,1-.409.164",
    transform: "translate(55.434 22.034)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5822",
    "data-name": "Trac\\xE9 5822",
    d: "M210.913,85.484a23.9,23.9,0,0,0,1.77,5.637c1.179,2.287-2.928,1.662-2.928,1.662Z",
    transform: "translate(56.72 23.116)",
    fill: "#ed847e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5823",
    "data-name": "Trac\\xE9 5823",
    d: "M241.3,180.3l-.939,9.113a202.225,202.225,0,0,1-28.254-1.775,123.314,123.314,0,0,1-14.348-2.691,61.428,61.428,0,0,1-7.451-2.318c-1.288-.508-2.589-1.062-3.957-1.763a25.589,25.589,0,0,1-4.319-2.748c-.4-.328-.769-.621-1.175-1.018l-.6-.577-.61-.667a18.2,18.2,0,0,1-1.2-1.537,14.362,14.362,0,0,1-1.119-1.989,13.254,13.254,0,0,1-.87-2.42l-.295-1.154c-.192-.757-.294-1.39-.452-2.091-.508-2.679-.836-5.134-1.119-7.587-.542-4.862-.824-9.6-1.029-14.314l-.2-7.044-.022-7.009c.056-4.693.146-9.306.474-14.043l20.341.734c.011,8.967-.215,18.1-.3,27.046-.057,4.477-.069,8.942.033,13.239.057,2.138.147,4.264.328,6.129.046.385.069.837.124,1.188a19.4,19.4,0,0,0,2.94,1.831c1.652.86,3.528,1.7,5.462,2.465,3.912,1.55,8.107,2.9,12.369,4.172,8.526,2.522,17.424,4.7,26.2,6.83",
    transform: "translate(46.873 31.548)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5824",
    "data-name": "Trac\\xE9 5824",
    d: "M226.05,167.368s9.452-2.489,11.45-2.077c2.235.459,1.2,12.237-1.688,13.85s-10.087-3.614-10.087-3.614c-1.668-3.833-1.147-6.973.325-8.159",
    transform: "translate(60.759 44.684)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5825",
    "data-name": "Trac\\xE9 5825",
    d: "M225.76,167.9a13.683,13.683,0,0,1,4.318-3.1c2.128-.75,4.206-1.847,5.177-1.469s-2.343,2.918-2.343,2.918Z",
    transform: "translate(61.049 44.148)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5826",
    "data-name": "Trac\\xE9 5826",
    d: "M235.53,165.281s5.806,1.64,7.654,4.036-3.358.95-3.358.95,6.057,2.2,3.557,6.823c-1.226,2.266-8.2,2.716-11.411,2.3,0,0,.09-9.839,3.557-14.11",
    transform: "translate(62.729 44.694)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5827",
    "data-name": "Trac\\xE9 5827",
    d: "M194.8,102.919s-3.821-.138-6.742,4.1l12.53,14.746s-.094-5.323,6.784-6.286c0,0-9.28-6.717-12.572-12.561",
    transform: "translate(50.853 27.831)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6531",
    "data-name": "Groupe 6531",
    transform: "translate(238.911 130.75)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6530",
    "data-name": "Groupe 6530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6529",
    "data-name": "Groupe 6529",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5828",
    "data-name": "Trac\\xE9 5828",
    d: "M194.8,102.919s-3.821-.138-6.742,4.1l12.53,14.746s-.094-5.323,6.784-6.286c0,0-9.28-6.717-12.572-12.561",
    transform: "translate(-188.058 -102.919)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5829",
    "data-name": "Trac\\xE9 5829",
    d: "M203.262,115.426s.8-8.272,1.349-10.035l.713-2.273s4.927.079,6.614,2.554l-.667,12.6a14.681,14.681,0,0,0-8.009-2.847",
    transform: "translate(54.965 27.885)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6534",
    "data-name": "Groupe 6534",
    transform: "translate(258.227 131.003)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6533",
    "data-name": "Groupe 6533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6532",
    "data-name": "Groupe 6532",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5830",
    "data-name": "Trac\\xE9 5830",
    d: "M203.262,115.426s.8-8.272,1.349-10.035l.713-2.273s4.927.079,6.614,2.554l-.667,12.6a14.681,14.681,0,0,0-8.009-2.847",
    transform: "translate(-203.262 -103.118)",
    fill: "#fff"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.0f3970862432d3ccee89f607b84f8d12.svg";
export { ForwardRef as ReactComponent };